export class FacebookNotInitializedError extends Error {
  constructor() {
    super("partner.edit.facebookInitializationError");
  }
}
